import React, { Suspense } from 'react'
import { SLUG_DOES_NOT_EXIST } from '~constants'
import { DynamicComponent } from '~elements'
import { getStaticPropsForPage } from '../../lib/hygraph/getStaticPropsForPage'

const Error = (props: any) => {
  const blocks = props?.story?.content?.body?.blocks || []

  const componentsList =
    blocks &&
    blocks.length > 0 &&
    blocks.map((block: any) => {
      return <DynamicComponent key={block?.id} block={{ ...block }} />
    })

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>{componentsList}</Suspense>
    </>
  )
}

export async function getStaticProps({ preview = false }: { preview: boolean }) {
  return await getStaticPropsForPage({ slug: SLUG_DOES_NOT_EXIST, preview })
}

export default Error
